import * as tslib_1 from "tslib";
import InboxRulesSection from './InboxRulesSection';
import getActionClauseTypeOptions from '../actions/helpers/getActionClauseTypeOptions';
import getConditionalExceptionClauseTypeOptions from '../actions/helpers/getConditionalExceptionClauseTypeOptions';
import resetInboxRuleEdit from '../actions/resetInboxRuleEdit';
import setIgnoreSubsequentRules from '../actions/helpers/setIgnoreSubsequentRules';
import store from '../store/store';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import setEditStateShouldRunRuleNow from '../mutators/setEditStateShouldRunRuleNow';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import canRunCurrentEditRule from '../selectors/canRunCurrentEditRule';
var styles = require('./InboxRulesEdit.scss');
var stopProcessingRulesLearnMoreUrl = 'https://support.office.com/en-US/client/results?Shownav=true&lcid=1033&ns=OLWAO365B&version=15&omkt=en-US&ver=15&v=15.20.298.0&mode=Desktop&helpid=ms.exch.owab.InboxRulesStopProcessing';
var InboxRulesEdit = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesEdit, _super);
    function InboxRulesEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesEdit.prototype.componentWillUnmount = function () {
        resetInboxRuleEdit();
    };
    InboxRulesEdit.prototype.render = function () {
        var showExceptions = store.inboxRulesEditState.exceptionClauseIds.length > 0;
        return (React.createElement("div", null,
            this.getInboxRulesSection('name'),
            this.getInboxRulesSection('conditional'),
            this.getInboxRulesSection('action'),
            showExceptions && this.getInboxRulesSection('exception'),
            this.renderIgnoreSubsequentRulesCheckbox()));
    };
    InboxRulesEdit.prototype.getInboxRulesSection = function (sectionType) {
        var editState = store.inboxRulesEditState;
        switch (sectionType) {
            case 'name':
                return React.createElement(InboxRulesSection, { sectionType: sectionType, numStep: 1 });
            case 'conditional':
                return (React.createElement(InboxRulesSection, { sectionType: sectionType, numStep: 2, clauseIds: editState.conditionalClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions() }));
            case 'action':
                return (React.createElement(InboxRulesSection, { sectionType: sectionType, numStep: 3, clauseIds: editState.actionClauseIds, clauseTypeOptions: getActionClauseTypeOptions() }));
            case 'exception':
                return (React.createElement(InboxRulesSection, { sectionType: sectionType, numStep: 4, clauseIds: editState.exceptionClauseIds, clauseTypeOptions: getConditionalExceptionClauseTypeOptions() }));
            default:
                throw new Error('Cannot get inbox rule section component for a section type that does not exist');
        }
    };
    InboxRulesEdit.prototype.renderIgnoreSubsequentRulesCheckbox = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.ignoreSubsequentRulesCheckbox },
                React.createElement(OptionsCheckbox, { checked: store.inboxRulesEditState.ignoreSubsequentRules, label: strings.options_inboxRules_stopProcessingRules, onChange: function (ev, checked) { return setIgnoreSubsequentRules(checked); } }),
                React.createElement(IconButton, { iconProps: {
                        iconName: "Info" /* Info */,
                        styles: {
                            root: styles.infoIcon,
                        },
                    }, onClick: function () {
                        var infoWindow = window.open(stopProcessingRulesLearnMoreUrl, '_blank', 'height = 500, width=400');
                        if (infoWindow.focus) {
                            infoWindow.focus();
                        }
                    } })),
            isMailFeatureEnabled('tri-bulkActionNotification') &&
                isMailFeatureEnabled('tri-runRulesNow') &&
                canRunCurrentEditRule() && (React.createElement("div", { className: styles.runRuleNowCheckbox },
                React.createElement(OptionsCheckbox, { checked: store.inboxRulesEditState.shouldRunRuleNow, label: strings.options_inboxRules_runRuleNow, onChange: function (ev, checked) { return setEditStateShouldRunRuleNow(checked); } })))));
    };
    InboxRulesEdit = tslib_1.__decorate([
        observer
    ], InboxRulesEdit);
    return InboxRulesEdit;
}(React.Component));
export default InboxRulesEdit;
//# sourceMappingURL=InboxRulesEdit.js.map